import { API_HOST_NAME } from "../../constants.js"
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js"

const useServiceLogsMessagesResources = (teamId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/service_log_messages`
  return useAuthenticatedResources(url)
}

export default useServiceLogsMessagesResources
